import { useEffect } from 'react'

import { useWpDataStore } from '../state/wpDataStore'

export function useWpDataInit(perPage = 20, fetchAll = true) {
  const loadAll = useWpDataStore((s) => s.loadAll)
  const loading = useWpDataStore((s) => s.loading)
  const systems = useWpDataStore((s) => s.systems)
  const cases = useWpDataStore((s) => s.cases)

  useEffect(() => {
    // only load if we have nothing yet
    if (!systems && !cases && !loading) {
      loadAll({ perPage, fetchAll })
    }
  }, [systems, cases, loading, perPage, fetchAll, loadAll])
}
